import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState, useEffect } from 'react';
import { func, node } from 'prop-types';

const ToolbarToggle = _ref => {
  let {
    onChange
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["onChange"]);

  const items = React.Children.toArray(props == null ? void 0 : props.children);
  const [index, setIndex] = useState(0);

  const rotateIndex = () => {
    if (index >= items.length - 1) {
      setIndex(0);
      return;
    }

    setIndex(index + 1);
  };

  useEffect(() => {
    const {
      props: {
        value,
        children
      }
    } = items[index];
    onChange({
      id: value,
      label: children
    });
  }, [index]);
  const children = items.map(child => /*#__PURE__*/React.cloneElement(child, {
    onClick: rotateIndex
  }));
  return children[index];
};

process.env.NODE_ENV !== "production" ? ToolbarToggle.propTypes = {
  children: node,
  onChange: func
} : void 0;
export default ToolbarToggle;